import { useMapTooltipDisplayData } from "../useMapTooltipDisplayData"

// RoadAccidentSegments
export default function RASContent() {
    const { displayData } = useMapTooltipDisplayData()
    const { TotalAccidentNumber, Status } = displayData ?? {}

    return (
        <>
            <div className="tooltip-info-row">Количество ДТП: {TotalAccidentNumber}</div>
            <div className="tooltip-info-row">Статус участка: {Status ?? "Не известен"}</div>
        </>
    )
}
